import _ from 'lodash';
import update from 'react-addons-update';

import { SharedAppConstants } from '@tock/shared-app-constants';
import { dashboard } from 'types';
import { safeToNumber } from '@tock/coretypes';

export const initialState: State = {
  configuredTags: [],
  isInitialized: false,
  requestInProgress: false,
};

interface State {
  configuredTags: dashboard.Tag[];
  isInitialized: boolean;
  requestInProgress: boolean;
}

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload, context } = action;

  switch (type) {
    case SharedAppConstants.TAGS_FETCH_ALL_DONE: {
      return {
        ...state,
        configuredTags: _.orderBy(payload, 'text'),
        isInitialized: true,
        requestInProgress: false,
      };
    }
    case SharedAppConstants.TAGS_FETCH_ALL_FAILED: {
      return {
        ...state,
        isInitialized: true,
        requestInProgress: false,
      };
    }
    case SharedAppConstants.TAG_PRIORITY_UPDATE_FAILED:
    case SharedAppConstants.TAG_ADD_DONE: {
      const newData = _.uniq(_.concat(state.configuredTags, [payload])).sort();
      return {
        ...state,
        configuredTags: newData,
      };
    }
    case SharedAppConstants.TAG_PRIORITY_UPDATE_STARTING:
    case SharedAppConstants.TAGS_FETCH_ALL_STARTING:
    case SharedAppConstants.TAG_REMOVE_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case SharedAppConstants.TAG_PRIORITY_UPDATE_DONE:
    case SharedAppConstants.TAG_REMOVE_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case SharedAppConstants.TAG_REMOVE_DONE: {
      const newData = _.filter(
        state.configuredTags,
        (tag) => safeToNumber(tag.id) !== safeToNumber(context.deletedTag.id)
      );

      return {
        ...state,
        configuredTags: newData,
      };
    }
    case SharedAppConstants.TAG_REORDER: {
      const { tags, draggedItemIndex, hoveredItemIndex } = payload;
      const draggedTag = tags[draggedItemIndex];

      const newTags = update(tags, {
        $splice: [
          [draggedItemIndex, 1],
          [hoveredItemIndex, 0, draggedTag],
        ],
      });

      const orderingMap = _.map(newTags, (tag, index) => ({
        id: tag.id,
        ordering: index,
      }));

      const data = _.map(state.configuredTags, (tag) => {
        const newOrdering = _.find(orderingMap, (entity) => entity.id === tag.id);

        if (newOrdering) {
          tag.ordering = newOrdering.ordering;
        }

        return tag;
      });

      return {
        ...state,
        configuredTags: data,
      };
    }

    default:
      return state;
  }
}
